import type {
  BillingCurrentPlan,
  BillingSubscription,
} from "@app/common/types";

export const UNKNOWN_SUBSCRIPTION: BillingSubscription = {
  plan: "unknown",
  settings: {
    customBotLogo: false,
    customBotName: false,
    monthlyFreeUploadCredits: 0,
    storeRecording: false,
  },
  quantity: 1,
  inTrialPeriod: false,
  monthlyUploadCreditBalance: 0,
  purchasedUploadCreditBalance: 0,
};

export const UNKNOWN_PLAN: BillingCurrentPlan = {
  label: null,
  type: "unknown",
  seatMaximum: 0,
};
